<template>
  <div class="project-structure-details">
    <div class="project-structure-details-header">
      <!-- <slot name="details_title" /> -->
      <div class="detail_header">
        <div class="detail_header_left">
          <slot name="details_title_left" />

        </div>
        <div class="detail_header_center">
          <slot name="details_title_center_top" />
          <div class="detail_header_center_bottom">
            <slot name="details_title_center_bottom" />
          </div>
        </div>
        <div class="detail_header_right">
          <slot name="details_title_right" />

        </div>
      </div>
    </div>

    <div class="project-structure-details-breadcrumbs">
      <slot name="detail_breadcrumbs" />
    </div>

    <div class="project-structure-details-tab">
      <!-- <div class="linked_line"></div> -->
      <!-- <v-tabs v-model="tab" center-active align-tabs="title" show-arrows grow height="30px" next-icon="keyboard_arrow_right"
        prev-icon="keyboard_arrow_left"
        class="project-structure-details-tabs">
        <v-tab v-for="(item, index) in tabs" :key="item.title" :value="index">
          {{ item.title }}
        </v-tab>
      </v-tabs> -->
      <div class="tab-container">
        <div 
          v-for="(tab, index) in tabs"
          :key="`tab${index}${tab.title}`"
          class="t-tab" 
          :style="index === selected_tab?'border-bottom: 2px solid white':''"
          @click="selected_tab = index"
          >
          <TText :text="tab.title" />
          <TIcon
          v-if="tab.content === 'ta_elements'"
          class="ml-1"
          name="power"
          :color="$store.state.ProjectStructure.show_taktarea_linked_edges?'#E91E63':'rgba(255,255,255,0.2)'"
          @click.native.prevent.stop="$emit('checkBoxClick', {key: 'show_taktarea_linked_edges', value: !$store.state.ProjectStructure.show_taktarea_linked_edges})"
          />
          <TIcon
          v-if="tab.content === 'elements'"
          class="ml-1"
          name="power"
          :color="$store.state.ProjectStructure.show_steps_linked_edges?'#009688':'rgba(255,255,255,0.2)'" 
          @click.native.prevent.stop="$emit('checkBoxClick', {key: 'show_steps_linked_edges', value: !$store.state.ProjectStructure.show_steps_linked_edges})"
          />
          <TIcon
          v-if="tab.content === 'shapes'"
          class="ml-1"
          name="power"
          :color="$store.state.ProjectStructure.show_taktareashapes?'#2196F3':'rgba(255,255,255,0.2)'" 
          @click.native.prevent.stop="$emit('checkBoxClick', {key: 'show_taktareashapes', value: !$store.state.ProjectStructure.show_taktareashapes})"
          />

          <!-- test commented out replaced with power icon -->
          <template v-if="false">
          <RadialCheckbox
            v-if="tab.content === 'ta_elements'"
            foreground_color="white"
            shadow="black"
            @click.native.prevent.stop="$emit('checkBoxClick', {key: 'show_taktarea_linked_edges', value: !$store.state.ProjectStructure.show_taktarea_linked_edges})"
            :is_checked="$store.state.ProjectStructure.show_taktarea_linked_edges"
          />
          <RadialCheckbox
            v-if="tab.content === 'elements'"
            foreground_color="white"
            shadow="black"
            @click.native.prevent.stop="$emit('checkBoxClick', {key: 'show_steps_linked_edges', value: !$store.state.ProjectStructure.show_steps_linked_edges})"
            :is_checked="$store.state.ProjectStructure.show_steps_linked_edges"
          />
        </template>
          <!-- style="position: absolute; top: 5px; right: 5px" -->

        </div>
      </div>
      <!-- <div class="linked_line"></div> -->
    </div>
    <div class="project-structure-details-content">
      <slot :tab_content="tabs[selected_tab].content"/>
    </div>
    <div class="project-structure-details-btn">
      <slot name="details_btn" />
    </div>

  </div>
</template>


<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';

export default {
  props: ['tabs'],
  data: () => ({
    selected_tab: 0,
  }),
  watch: {
    tabs(val) {
      if (this.selected_tab > val.length-1) {
        this.selected_tab = val.length - 1;
      }
    },
  },
  components: {
        TIcon,
        RadialCheckbox,
    },
}
</script>


<style>
.detail_header {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  height: auto;
}

.detail_header_left {
  display: flex;
  align-items: center;
  margin: 0 4px;
}

.detail_header_center {
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  height: 100%;
  width: auto;
  white-space: normal;
}

.detail_header_center_bottom {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.detail_header_right {
  justify-content: flex-end;
  display: flex;
  align-items: center;
  margin: 0 4px;
  white-space: nowrap;
}

.project-structure-details {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  pointer-events: all;
  user-select: text;
  background: rgba(39, 39, 39, 0.7);
  backdrop-filter: blur(24px) brightness(95%);
  -webkit-backdrop-filter: blur(24px) brightness(95%);

  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);

}

.linked_line {
  height: 1px;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%, rgba(252, 252, 254, 0) 100%);
}

.theme--dark.v-tabs > .v-tabs-bar {
  background-color: rgba(39,39,39,0.7);
  backdrop-filter: blur(24px) brightness(95%);
  -webkit-backdrop-filter: blur(24px) brightness(95%);
}

.project-structure-details-header {
  /* height: 40px; Wegen neuen title header*/
  display: block;
  flex-direction: row;
  justify-content: space-between;
}

.project-structure-details-content {
  overflow: scroll;
  overflow-x: hidden;
  height: 100%;
}
.tab-container {
  display: flex;
  width: 100%;
}
.t-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
}

.project-structure-details-breadcrumbs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 4px 8px;
}
</style>
  